import React from "react";
import "./VerdorApk.css";
import { FaDownload } from "react-icons/fa6";

export default function VendorApkDownloader() {
  return (
    <header className="hero-section">
      <div className="hero-overlay"></div>

      <div className="hero-container">
        <div className="hero-content">
          <h1>
            Empower Your Business With <span>VendorPayments</span>
          </h1>
          <p>
            The ultimate solution for managing vendor transactions. Secure,
            reliable, and faster than ever. Download the official APK now.
          </p>

          <div className="hero-action-area">
            <a
              href="/VendorPayments.apk"
              download
              className="main-download-btn"
            >
              <div className="btn-icon">
                <FaDownload classNameName="fa-download" />
              </div>
              <div className="btn-label">
                <span className="top-text">Download for Android</span>
                <span className="bottom-text">APK File</span>
              </div>
            </a>

            <div className="trust-badges">
              <span>
                <i className="fa-solid fa-circle-check"></i> Safe & Verified
              </span>
              <span>
                <i className="fa-solid fa-shield-virus"></i> Virus Free
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
